import { HeroBannerInfoProps } from '@/widgets/HeroBannerInfo'

import { FILES_URL } from '@/shared/lib/const/env'

// Временный костыль от Димы, нужно будет переписать

// Временный костыль от Димы, нужно будет переписать

// Временный костыль от Димы, нужно будет переписать
// const linkToMain = `/`
// const linkToShops = `/shops/`
const linkToService = `/service/`

export const stepsItemsFiz = {
	title: 'Как это работает',
	items: [
		{
			description: `Оформите страховку. Выберите подходящую программу у нас на сайте или в магазине.`
		},
		{
			description: `При наступлении страхового случая обратитесь в любой <a  href="${linkToService}" title="К сервисным центрам" target="_blank"> сервисный центр iPort</a>.`
		},
		{
			description: `Получите отремонтированное или новое устройство в кратчайшие сроки.`
		}
	]
}

export const categories = [
	{
		NAME: `iPhone`,
		LINK: `/catalog/apple_iphone/`,
		PICTURE: `https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/mock-images/HeadCategoriesImages/104.jpg`
	},
	{
		NAME: `Mac`,
		LINK: `/catalog/apple_mac/`,
		PICTURE: `https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/mock-images/HeadCategoriesImages/80.jpg`
	},
	{
		NAME: `iPad`,
		LINK: `/catalog/apple_ipad/`,
		PICTURE: `https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/mock-images/HeadCategoriesImages/87.jpg`
	},
	{
		NAME: `Watch`,
		LINK: `/catalog/apple_watch/`,
		PICTURE: `https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/mock-images/HeadCategoriesImages/125.jpg`
	},
	{
		NAME: `Airpods`,
		LINK: `/catalog/naushniki/filter/airpods/`,
		PICTURE: `https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/mock-images/airPods.jpg`
	}
]

export const faqItemsFiz = [
	{
		question: `Какие устройства можно застраховать?`,
		answer: `Застраховать можно следующие категории устройств: iPhone, iPad, Apple Watch, AirPods, Beats, Macbook, iMac.`
	},
	{
		question: `Для чего нужна страховка на iPhone?`,
		answer: `Полис страхования экономит средства клиента при разбитии, а также залитии, кражи и других рисков в зависимости от полиса.
    Купив страховку, клиент может обратиться бесплатно за ремонтом в наш сервисный центр.`
	},
	{
		question: `Как действует страховка на iPhone?`,
		answer: `При случайном повреждении клиент обращается в наш сервисный центр с устройством и документами.После диагностики клиент получит своё устройство восстановленным до состояния “как новое” или денежную компенсацию от страховой.`
	},
	{
		question: `Как купить страховку?`,
		answer: `Приобрести можно на сайте вместе с устройством или в розничном магазине.`
	},
	{
		question: `Какие риски покрывает страховой полис?`,
		answer: `В зависимости от программы страхования покрываются различные риски: механические повреждения/кража и прочие. Подробнее можно посмотреть при выборе конкретной категории товара.`
	},
	{
		question: `Можно ли вернуть денежные средства за страховой полис?`,
		answer: `В течение 14 дней можно обратиться в страховую компанию за возвратом страховой премии.`
	},
	{
		question: `Сколько действует договор страхования?`,
		answer: `Страховой полис действует от 1 года до 5 лет.`
	},
	{
		question: `Сколько стоит страховка на iPhone?`,
		answer: `Стоимость полиса зависит от стоимости устройства. Под каждую конкретную модель можно посмотреть стоимость на странице страхования или в карточке/корзине товара.`
	},
	{
		question: `Чем отличается гарантия от страхового полиса?`,
		answer: `Страховой полис покрывает поломки или повреждения, которые не покрывает стандартная гарантия от производителя. Как правило, это покрытие механических повреждений/кражи/залития и другие случайные риски внешнего воздействия.`
	},
	{
		question: `Что делать, если застрахованное устройство утеряно?`,
		answer: `У нас не представлены страховые программы, покрывающие риск потери устройства. В случае кражи ( если данный риск застрахован по полису), необходимо обратиться в страховую компанию с пакетом документов для получения возмещения.`
	},
	{
		question: `Что делать, если утерян страховой полис на устройство?`,
		answer: `Полис страхования направляется на электронную почту клиента, и всегда можно его восстановить. `
	},
	{
		question: `Что делать, если застрахованное устройство разбито?`,
		answer: `Следует обратиться в наш сервисный центр с пакетом документов и повреждённым устройством. Специалисты проведут диагностику и ремонт устройства в кратчайшие сроки.
`
	},
	{
		question: `Как действует страховой полис?`,
		answer: `При случайном повреждении клиент обращается в наш сервисный центр с устройством и документами. После диагностики и согласования со страховой компанией клиент получает своё отремонтированное или новое устройство.
`
	}
]

export const serialList = [
	{
		title: `iPhone 10`,
		value: `iPhone 10`
	},
	{
		title: `iPhone 11`,
		value: `iPhone 11`
	},
	{
		title: `iPhone 12`,
		value: `iPhone 12`
	},
	{
		title: `iPhone 13`,
		value: `iPhone 13`
	},
	{
		title: `iPhone 13 Pro`,
		value: `iPhone 13 Pro`
	},
	{
		title: `iPhone 13 Pro Max`,
		value: `iPhone 13 Pro Max`
	}
]

export const charList = [
	{
		title: `32 Гб`,
		value: `32Gb`
	},
	{
		title: `64 Гб`,
		value: `64Gb`
	},
	{
		title: `128 Гб`,
		value: `128Gb`
	},
	{
		title: `256 Гб`,
		value: `256Gb`
	},
	{
		title: `512 Гб`,
		value: `512Gb`
	}
]

export const TableItemList = [
	[
		{
			name: ``,
			value: `https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/mock-images/HomeCreditLogo.png`
		},
		{
			name: `Стоимость`,
			value: `8 000 ₽`
		},
		{
			name: `Повреждение заднего корпуса`,
			value: `Нет`
		},
		{
			name: `Повреждение отдельных деталей`,
			value: `Нет`
		},
		{
			name: `Гибель устройства`,
			value: `Да`
		},
		{
			name: `Залитие`,
			value: `Нет`
		},
		{
			name: `Кража`,
			value: `Да`
		},
		{
			name: `Обращение в СЦ`,
			value: `1 раз`
		},
		{
			name: `Страховая сумма`,
			value: `100%`
		},
		{
			name: `Повреждение экрана`,
			value: `Да`
		}
	],
	[
		{
			name: ``,
			value: `https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/mock-images/VSKLogo.png`
		},
		{
			name: `Стоимость`,
			value: `12 000 ₽`
		},
		{
			name: `Повреждение заднего корпуса`,
			value: `Да`
		},
		{
			name: `Повреждение отдельных деталей`,
			value: `Да`
		},
		{
			name: `Гибель устройства`,
			value: `Да`
		},
		{
			name: `Залитие`,
			value: `Да`
		},
		{
			name: `Кража`,
			value: `Да`
		},
		{
			name: `Обращение в СЦ`,
			value: `Не ограниченное количетсво в рамках страховой суммы`
		},
		{
			name: `Страховая сумма`,
			value: `100%`
		},
		{
			name: `Повреждение экрана`,
			value: `Да`
		}
	]
]

export const pdfListFiz = [
	{
		title: `Памятка по страхованию мобильных устройств ВСК`,
		link: `${FILES_URL}/files/pdf/insuranceNoteVSK.pdf`
	},
	{
		title: `Правила ВСК`,
		link: `${FILES_URL}/files/pdf/insuranceRulesVSK.pdf`
	},
	{
		title: `Правила страхования имущественных рисков Альфастрахование`,
		link: `${FILES_URL}/files/pdf/insurance/pravila_strahovaniya_imushestvennyh_riskov.pdf`
	}
]

export const heroBannerInfoData: HeroBannerInfoProps = {
	title: 'Страхование устройств',
	additional: [
		{
			title: 'Сервис',
			text: 'Бесплатное обслуживание \n' + 'в сервисных центрах iPort'
		},
		{
			title: 'Доступность',
			text: 'Быстрое оформление онлайн, в наших \n' + 'магазинах и у корпоративного менеджера'
		},
		{
			title: 'Надёжно',
			text: 'Широкое покрытие программы \n' + 'страхования '
		}
	],
	text: 'Защитите своё устройство от случайных повреждений.',
	buttonLabel: '',
	image: {
		src: 'https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/screens/Insurance/HeroInfoBanner.png',
		width: 534,
		height: 295,
		alt: ''
	},
	links: {
		business: {
			link: '/b2b/insurance/',
			text: 'Для бизнеса',
			isCurrent: false
		},
		regular: {
			link: '/services/insurance/',
			text: 'Частным лицам',
			isCurrent: true
		}
	}
}
